export default "__VITE_ASSET__tfwrxPJ1__"